export default function () {

    // all JS should be dependent on these
    const body = document.querySelector('body');
    const nav = document.querySelector('.nav');
    const navMenu = nav.querySelector('.navigation-left')
    const mobileNavTrigger = document.querySelector('.mobile-nav-trigger');
    
    // Search drawer elements
    const searchDrawer = document.querySelector('.search-drawer');
    const searchTriggers = document.querySelectorAll('.search-btn-trigger');
    const searchClose = searchDrawer.querySelector('.search-drawer__close');
    const searchOverlay = searchDrawer.querySelector('.search-drawer__overlay');
    const searchInput = searchDrawer.querySelector('.search-drawer__input');
    const searchTags = searchDrawer.querySelectorAll('.search-drawer__tag');
    const searchResults = searchDrawer.querySelector('.search-drawer__results');
    const searchSubmit = searchDrawer.querySelector('.search-drawer__submit');
    const searchSpinner = searchDrawer.querySelector('.search-drawer__spinner');
    const searchClear = searchDrawer.querySelector('.search-drawer__clear');
    
    let searchTimeout = null;
    let currentPage = 1;
    let currentQuery = '';
    const postsPerPage = 10;

    // Function to generate pagination HTML
    function generatePagination(total, current) {
        const totalPages = Math.ceil(total / postsPerPage);
        if (totalPages <= 1) return '';

        let links = [];
        
        // Previous page
        if (current > 1) {
            links.push(`<a class="prev page-numbers" href="#" data-page="${current - 1}"><i class="fa-solid fa-chevron-left"></i></a>`);
        }

        // First page
        links.push(`<a class="page-numbers${current === 1 ? ' current' : ''}" href="#" data-page="1">1</a>`);

        // Dots after first page
        if (current > 3) {
            links.push('<span class="page-numbers dots">…</span>');
        }

        // Pages around current
        for (let i = Math.max(2, current - 1); i <= Math.min(totalPages - 1, current + 1); i++) {
            if (i <= current + 1 && i >= current - 1) {
                links.push(`<a class="page-numbers${current === i ? ' current' : ''}" href="#" data-page="${i}">${i}</a>`);
            }
        }

        // Dots before last page
        if (current < totalPages - 2) {
            links.push('<span class="page-numbers dots">…</span>');
        }

        // Last page
        if (totalPages > 1) {
            links.push(`<a class="page-numbers${current === totalPages ? ' current' : ''}" href="#" data-page="${totalPages}">${totalPages}</a>`);
        }

        // Next page
        if (current < totalPages) {
            links.push(`<a class="next page-numbers" href="#" data-page="${current + 1}"><i class="fa-solid fa-chevron-right"></i></a>`);
        }

        return `
            <div class="row justify-content-center pagination-numbers">
                <div class="pagination">
                    ${links.join('')}
                </div>
            </div>
        `;
    }

    // Function to toggle search drawer
    function toggleSearchDrawer(show = true) {
        searchDrawer.setAttribute('aria-hidden', (!show).toString());
        body.style.overflow = show ? 'hidden' : '';
        
        if (show) {
            searchInput.focus();
            // Add click event listener to handle clicks outside drawer
            document.addEventListener('click', handleOutsideClick);
        } else {
            // Remove click event listener when drawer is closed
            document.removeEventListener('click', handleOutsideClick);
        }
    }

    // Function to handle clicks outside the drawer
    function handleOutsideClick(e) {
        if (!searchDrawer.contains(e.target) && 
            !e.target.classList.contains('search-btn-trigger') && 
            !e.target.closest('.search-btn-trigger')) {
            toggleSearchDrawer(false);
        }
    }

    // Function to show/hide spinner
    function setSpinner(visible) {
        if (visible) {
            searchSpinner.classList.add('active');
            searchSpinner.setAttribute('aria-hidden', 'false');
        } else {
            searchSpinner.classList.remove('active');
            searchSpinner.setAttribute('aria-hidden', 'true');
        }
    }

    // Function to perform search
    async function performSearch(query, page = 1) {
        try {
            setSpinner(true);
            currentQuery = query;
            currentPage = page;
            
            // Use the new AJAX endpoint for search
            const response = await fetch(`/wp-admin/admin-ajax.php?action=ra_search&s=${encodeURIComponent(query)}&paged=${page}`);
            const data = await response.json();
            const resultsHTML = data.results_html || '';
            const totalPosts = data.total || 0;
            const totalPages = data.total_pages || 1;
            
            if (!resultsHTML.trim()) {
                searchResults.innerHTML = '<article><h2>No results found.</h2></article>';
                setSpinner(false);
                return;
            }

            // Add search count if there are results
            const searchCountHTML = `
                <div class="search-count">
                    <h4>${totalPosts} Search Results for "${query}"</h4>
                </div>
            `;

            // Generate pagination
            const paginationHTML = generatePagination(totalPosts, page);

            searchResults.innerHTML = searchCountHTML + resultsHTML + paginationHTML;
            setSpinner(false);

            // Add pagination click handlers
            const paginationLinks = searchResults.querySelectorAll('.pagination a');
            paginationLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const newPage = parseInt(e.target.dataset.page);
                    performSearch(currentQuery, newPage);
                    // Scroll results back to top
                    searchResults.scrollTop = 0;
                });
            });

        } catch (error) {
            console.error('Search error:', error);
            searchResults.innerHTML = '<article><h2>An error occurred while searching.</h2></article>';
            setSpinner(false);
        }
    }

    // Utility to update clear button visibility
    function updateClearButton() {
        if (searchClear) {
            searchClear.style.visibility = searchInput.value.trim().length > 0 ? 'visible' : 'hidden';
        }
    }

    // Event Listeners for search functionality
    if (searchDrawer && searchTriggers.length) {
        // Open search drawer
        searchTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleSearchDrawer(true);
            });
        });

        // Close search drawer
        searchClose.addEventListener('click', () => {
            toggleSearchDrawer(false);
        });

        // Handle escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && searchDrawer.getAttribute('aria-hidden') === 'false') {
                toggleSearchDrawer(false);
            }
        });

        // Handle search input
        searchInput.addEventListener('input', (e) => {
            const query = e.target.value.trim();
            updateClearButton();
            // Remove active class from any selected tag
            searchTags.forEach(tag => tag.classList.remove('active'));
            // Clear existing timeout
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
            // Set new timeout for search
            searchTimeout = setTimeout(() => {
                if (query.length >= 3) {
                    setSpinner(true);
                    performSearch(query);
                } else {
                    searchResults.innerHTML = '';
                    setSpinner(false);
                }
            }, 300);
        });

        // Handle search submit button
        searchSubmit.addEventListener('click', () => {
            const query = searchInput.value.trim();
            if (query.length >= 3) {
                setSpinner(true);
                performSearch(query);
            }
        });

        // Handle form submission (pressing enter)
        searchInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                const query = searchInput.value.trim();
                if (query.length >= 3) {
                    setSpinner(true);
                    performSearch(query);
                }
            }
        });

        // Handle popular search tags
        searchTags.forEach(tag => {
            tag.addEventListener('click', () => {
                const query = tag.textContent.trim();
                searchInput.value = query;
                updateClearButton();
                setSpinner(true);
                performSearch(query);
                // Update active state
                searchTags.forEach(t => t.classList.remove('active'));
                tag.classList.add('active');
            });
        });

        // Handle clear button click
        if (searchClear) {
            searchClear.addEventListener('click', () => {
                searchInput.value = '';
                updateClearButton();
                searchInput.focus();
                searchResults.innerHTML = '';
                setSpinner(false);
            });
        }
    }

    // TODO: make this more utility-based, functional, or a class. It's too far-reaching.
    if (body && nav && navMenu && mobileNavTrigger) {
        const isDesktopWidth = window.matchMedia('(min-width: 992px)');

        // toggles mobile hamburger menu
        function toggleMobileMenu() {
            body.classList.toggle('disable-scroll');
            mobileNavTrigger.classList.toggle('active');
            nav.classList.toggle('mobile-menu-open');

            // if the classlist contains active, turn off search
            if (mobileNavTrigger.classList.contains('active')){
                toggleSearchDrawer(false);
            }
        }

        // opens submenu
        function openSubmenu(submenu, submenuToggle) {
            submenu.classList.add('sub-menu-open');
            submenuToggle.classList.add('flip-chevron');

            // and toggle the aria stuff
            submenu.setAttribute('aria-hidden', 'false');
            submenuToggle.setAttribute('aria-expanded', 'true');
        }

        // closes submenu
        function closeSubmenu(submenu, submenuToggle) {
            submenu.classList.remove('sub-menu-open');
            submenuToggle.classList.remove('flip-chevron');

            // and toggle the aria stuff
            submenu.setAttribute('aria-hidden', 'true');
            submenuToggle.setAttribute('aria-expanded', 'false');
        }

        // mobile nav controller
        mobileNavTrigger.addEventListener('click', event => {
            toggleMobileMenu();
        });

        // allows escape key to close mobile nav
        window.addEventListener('keyup', event => {
            if (event.key === 'Escape') {
                // if the mobile menu is open
                if (nav.classList.contains('mobile-menu-open')) {
                    // close any open submenu
                    const visibleSubmenu = document.querySelector('.sub-menu-open');
                    if (visibleSubmenu) {
                        const visibleSubmenuToggle = visibleSubmenu.previousSibling;
                        closeSubmenu(visibleSubmenu, visibleSubmenuToggle);
                    }
                    //and close the mobile menu
                    toggleMobileMenu();
                }
            }
        });

        // closes mobile menu and any open submenu
        function closeMobileMenu (event) {
            if (event.matches || override) {
                // if the mobile menu is open
                if (nav.classList.contains('mobile-menu-open')) {
                    // close any open submenu
                    const visibleSubmenu = document.querySelector('.sub-menu-open');
                    if (visibleSubmenu) {
                        const visibleSubmenuToggle = visibleSubmenu.previousSibling;
                        closeSubmenu(visibleSubmenu, visibleSubmenuToggle);
                    }
                    // and close the mobile menu
                    toggleMobileMenu();
                }
            }
        }

        // handles closing mobile menu and any open submenu when screen is resized from mobile to desktop
        isDesktopWidth.addEventListener('change', closeMobileMenu);

        // handles submenu open/close on click (mobile)
        function handleSubmenuToggleClicks(event){
            const clickTarget = event.target;
            const closestSubmenu = event.target.nextSibling;

            // if the submenu toggle is clicked
            if (!closestSubmenu.classList.contains('sub-menu-open')) {
                const visibleSubmenu = document.querySelector('.sub-menu-open');
                // if there is a submenu already open, close it
                if (visibleSubmenu) {
                    const visibleSubmenuToggle = visibleSubmenu.previousElementSibling;
                    closeSubmenu(visibleSubmenu, visibleSubmenuToggle);
                }
                // then open the new one
                openSubmenu(closestSubmenu, clickTarget);
            } else if (closestSubmenu.classList.contains('sub-menu-open')) {
                // if the submenu itself is open, close it
                closeSubmenu(closestSubmenu, clickTarget)
            } else {
                // do nothing
            }
        }

        // handles submenu open/close on key events (desktop)
        function handleSubmenuToggleKeys(event) {
            const keyTarget = event.target;
            const closestSubmenu = keyTarget.nextSibling;
            // allow submenu toggling when using enter key or space bar
            if (event.key === 'Enter' || event.key === ' ') {
                // if the targeted submenu isn't already open
                if (!closestSubmenu.classList.contains('sub-menu-open')) {
                    const visibleSubmenu = document.querySelector('.sub-menu-open');
                    //if there is a submenu already open, close it
                    if (visibleSubmenu) {
                        const visibleSubmenuToggle = visibleSubmenu.previousElementSibling;
                        closeSubmenu(visibleSubmenu, visibleSubmenuToggle);
                    }
                    // then open the new one
                    openSubmenu(closestSubmenu, keyTarget);
                } else if (closestSubmenu.classList.contains('sub-menu-open')) {
                    // if the submenu itself is open, close it
                    closeSubmenu(closestSubmenu, keyTarget);
                }
            }

            // allow escape key to close submenu
            if (event.key === 'Escape') {
                if (closestSubmenu.classList.contains('sub-menu-open')) {
                    // if the submenu is already open, close it
                    closeSubmenu(closestSubmenu, keyTarget);
                }
            }
        }

        // toggles click listeners on mobile to key listeners on desktop
        function toggleKeyClickListeners(event) {
            if (event.matches) {
                // if is desktop width
                // attach the keys listener
                navMenu.addEventListener('keyup', handleSubmenuToggleKeys);
                // and remove the click listener
                navMenu.removeEventListener('click', handleSubmenuToggleClicks);
            } else {
                // if is mobile width
                // attach the click listener
                navMenu.addEventListener('click', handleSubmenuToggleClicks);
                // and remove the keys listener
                navMenu.removeEventListener('keyup', handleSubmenuToggleKeys);
            }
        }

        // handles toggling submenu click and key listeners when screen size changes
        isDesktopWidth.addEventListener('change', toggleKeyClickListeners);

        // also attach the proper listener on page load
        toggleKeyClickListeners(isDesktopWidth);

        // if focus moves from the main nav, close any open submenu
        function handleNavFocus(event) {
            const mainNav = event.currentTarget;
            // give browser time to focus the next element
            requestAnimationFrame(() => {
                // check if the new focused element is a child of the original container
                if (!mainNav.contains(document.activeElement)) {
                    const visibleSubmenu = document.querySelector('.sub-menu-open');
                    // if there is a submenu already open, close it
                    if (visibleSubmenu) {
                        const visibleSubmenuToggle = visibleSubmenu.previousElementSibling;
                        // close the open submenu
                        closeSubmenu(visibleSubmenu, visibleSubmenuToggle);
                    }
                }
            });
        }

        // handles closing an open submenu when focus leaves the main nav
        navMenu.addEventListener('focusout', handleNavFocus);
    }
}
